import Link from 'next/link';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons/Button';
import { Tabs } from '@/components/Deposit/components/ChooseYourBonus/hooks/useIsBonusCardCode';
import { Modals } from '@/helpers/modals';
import { useDepositStore, useModalsStore } from '@/store';
import { ScEmptyState } from './styled';

export const EmptyState: FC = () => {
  const { t } = useTranslation('bonuses');
  const open = useModalsStore.use.open();
  const setInitialBonusTab = useDepositStore.use.setInitialBonusTab();

  const handleOpenDepositWithPromocode = () => {
    setInitialBonusTab(Tabs.PROMOCODE);
    open(Modals.Deposit);
  };

  return (
    <ScEmptyState>
      <h3 className="title">{t('activeBonuses.title')}</h3>
      <p className="description">{t('activeBonuses.emptyDescription')}</p>

      <div className="btn-explore-offers-container">
        <Button primary small to="/promotions?tab=casino" wide>
          {t('activeBonuses.exploreOffers')}
        </Button>
      </div>

      <p className="promo-hint">{t('activeBonuses.promoHint')}</p>

      <div className="links">
        <Link href="/promotions?tab=casino&block=promocode">
          {t('activeBonuses.noDepositCodes')}
        </Link>
        <button onClick={handleOpenDepositWithPromocode} type="button">
          {t('activeBonuses.depositCodes')}
        </button>
      </div>
    </ScEmptyState>
  );
};
